<div class="flex justify-center">
    <h2 class="font-light leading-relaxed text-3xl py-8 text-gray-800 cursor-default">{{city}} FOOD2030 Impacts</h2>
</div>
<div class="flex justify-center">
    <div class="relative w-1/3">
        <img alt="..." src="../../../../../../assets/img/food2030.png" class="rounded-full">
        <div class="absolute top-0 right-0">
            <div class="spinner-container">
                <mat-progress-spinner #spinner [color]="color" [mode]="mode" [value]="priorities.Climate">
                </mat-progress-spinner>
                <div class="spinner-background">{{priorities.Climate}}%</div>
            </div>
        </div>
        <div class="absolute top-0 left-0">
            <div class="spinner-container">
                <mat-progress-spinner #spinner [color]="color" [mode]="mode" [value]="priorities.Nutrition">
                </mat-progress-spinner>
                <div class="spinner-background">{{priorities.Nutrition}}%</div>
            </div>
        </div>
        <div class="absolute bottom-0 left-0">
            <div class="spinner-container">
                <mat-progress-spinner #spinner [color]="color" [mode]="mode" [value]="priorities.Innovation">
                </mat-progress-spinner>
                <div class="spinner-background">{{priorities.Innovation}}%</div>
            </div>
        </div>
        <div class="absolute bottom-0 right-0">
            <div class="spinner-container">
                <mat-progress-spinner #spinner [color]="color" [mode]="mode" [value]="priorities.Circularity">
                </mat-progress-spinner>
                <div class="spinner-background">{{priorities.Circularity}}%</div>
            </div>
        </div>
    </div>
</div>
